module.exports = __webpack_public_path__ + "static/media/rex.999c68a0.jpg";